import * as React from 'react';
import { MapPageFormFilter } from './Filters';
import { GlobalContext } from "../../../Contexts/GlobalContext";
import * as UserRepository from "../../../Repository/UserRepository";
import { Select, message } from 'antd';

interface ValidatorFilterProps extends MapPageFormFilter { }

export default function ValidatorFilter(props: ValidatorFilterProps) {
    const { value: formValue, onChange: updateForm, isLoading } = props;
    const { contract } = React.useContext(GlobalContext);
    const [validators, setValidators] = React.useState<any[]>([]);
    const [loading, setLoading] = React.useState(false);

    React.useEffect(() => {
        const fetchValidators = async () => {
            if (!contract) return;

            setLoading(true);
            try {
                await UserRepository.getUsersList({
                    params: { contractId: contract.id },
                    successCallback: (users: any[]) => {
                        const filteredValidators = users.filter(user =>
                            user.roles && user.roles.includes('ROLE_VALIDATOR')
                        ).map(user => ({
                            label: `${user.first_name} ${user.last_name}`,
                            value: user.id
                        }));
                        setValidators(filteredValidators);
                    }
                });
            } catch (err) {
                console.error(err);
                message.error('Failed to fetch validators');
            } finally {
                setLoading(false);
            }
        };

        fetchValidators();
    }, [contract]);

    return (
        <Select
            disabled={isLoading || loading}
            loading={loading}
            placeholder='Select a validator'
            options={validators}
            value={formValue}
            allowClear
            onChange={(value) => {
                updateForm && updateForm(value);
            }}
        />
    );
}
